import { useState } from 'react';
import { useResolution886Report } from '@/context/Resolution886Report';
import { AssessmentResponse } from '@/context/Resolution886Report/types';

export function useCreateReview() {
	const { form, newReview, lastReview, previousReview } = useResolution886Report();
	const [useReviewFiles, setUseReviewFiles] = useState<boolean>(false);

	function handleSetUseReviewFiles(value: boolean) {
		if (value) {
			const file_list_id =
				lastReview?.assessments?.map((a: AssessmentResponse) => a.file.id) ||
				previousReview?.files?.map((a: any) => a.id) ||
				[];

			form.setFieldsValue({ file_list_id });
		} else {
			form.setFieldsValue({ file_list_id: [] });
		}

		setUseReviewFiles(value);
	}

	return {
		newReview,
		previousReview,
		useReviewFiles,
		handleSetUseReviewFiles
	};
}
